import { styled as muiStyled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export const StyledDataGrid = muiStyled(DataGrid)({
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
    width: "5px",
  },
  "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
    background: "var(--dp-border-strong)",
    borderRadius: "5px",
  },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
    outline: "none !important",
  },
  "& .MuiCheckbox-root.Mui-disabled": {
    display: "none",
  },
  "& .MuiDataGrid-cell[data-field='actions']": {
    justifyContent: "flex-end",
  },
  "& .MuiDataGrid-cell[data-field='actions'] .MuiSvgIcon-root": {
    fontSize: "1.15rem",
  },
});

export const ContainerDataGrid = styled.div`
  & .container-preview-img {
    & .LowerContainer {
      display: none;
    }
  }
`;

export const ContainerToolbarItems = styled.div`
  width: 100%;
`;

export const SubContainer = styled.div`
  flex-grow: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
